import { createFileRoute } from "@tanstack/react-router";
import { GameDebugPage } from "@/features/debug/GameDebugPage";

export const Route = createFileRoute("/_authenticated/play_/$gameId/debug")({
  staticData: { access: { anyOf: ["agents.manage"] } },
  head: () => ({ meta: [{ title: "Debugging · Pax.co" }] }),
  component: DebugPage,
});

function DebugPage() {
  const { gameId } = Route.useParams();
  return <GameDebugPage gameId={gameId} />;
}
